<template lang="">
      <v-container >

         <v-dialog
      v-model="this.dialogRegistrada"
      max-width="290"
    >
      
      <v-card>
        <v-card-title class="text-h5">
          Registro Satisfactorio
        </v-card-title>
        <v-card-text>Ha sido registrado como acompañante en la actividad de Canoa por el Río Cares.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn
            color="green darken-1"
            text
            @click="dialogRegistrada = false"
          >
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      

        <v-row class="mb-2 mt-0" justify="center">
	                      <v-img
	                alt="Canoe Logo"
	                class="shrink ml-2 mr-2"
	                contain
	                :src="logoProveedor"
	                transition="scale-transition"
	                width="300"
	                height="80"
	              />  
                  </v-row>

         <v-row class="mb-2 mt-2" justify="center">
                      <h1> {{ this.reserva!= null? this.reserva.actividad.nombre: ''}} </h1> 
                  </v-row>         
        <v-row class="mt-2" justify="center">
          <v-col class="mr-1 mr-1" md="5" justify="center">
            <v-card
             v-if="!user" class="mt-2 elevation-12" color="rgb(100, 100, 100, 0.8)">
              <v-toolbar dense :color="colorBoton" flat>
               <v-row dense justify="center">
                <v-toolbar-title dense center v-bind:style= "{ color: colorBase}">
                  RESERVA NUMERO {{this.reserva!= null? this.reserva.id : ''}}
                </v-toolbar-title>
                </v-row>
              </v-toolbar>

                <v-card-text>

                  <v-form  @submit.prevent="$emit('login')" id="login-form">

                     <v-row dense>
            <v-col>
             


              <v-chip
                class="ml-4 mr-4"
                :color="colorBoton"
              >
        <v-avatar left>
          <v-icon>mdi-calendar</v-icon>
        </v-avatar>
        <h5>{{  new Date(reserva.fecha).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}}</h5>
      </v-chip>
            </v-col>

            <v-col>
              <v-text-field
                v-model="reserva.hora"
                 outlined
                dense
                label="Hora"
                prepend-icon="mdi-clock"
                type="time"
                readonly
                class="ml-4 mr-4"
              ></v-text-field>
            </v-col>
          </v-row>


	                  <v-text-field
	                  class="mr-4 ml-4"
	                    v-model="userNew.nombre"
	                    label="Nombre"
	                    name="nombre"
	                    required
	                    prepend-icon="mdi-account-circle"
	                    type="text"
	                    autocomplete="off"
	                    outlined
                dense
                  >
                  </v-text-field>

                   <v-text-field
                    class="mr-4 ml-4"
	                    v-model="userNew.telefono1"
	                    required
                    label="Teléfono"
                    name="telefono"
                    prepend-icon="mdi-phone-classic"
                    type="text"
                    autocomplete="off"
                    outlined
                dense
                    
                  >
                  </v-text-field>
                  <v-text-field
                   class="mr-4 ml-4"
	                    v-model="userNew.email"
	                    required
                    label="Email"
                    name="telefono"
                    prepend-icon="mdi-email-open"
                    type="text"
                    autocomplete="off"
                    outlined
                dense
                    
                  >
                  </v-text-field>

                  <v-text-field
                    class="mr-4 ml-4"
	                    v-model="userNew.dni"
	                    required
                    label="DNI"
                    name="dni"
                    prepend-icon="mdi-card-account-details-outline"
                    type="text"
                    autocomplete="off"
                    outlined
                    dense
                  >
                  </v-text-field>

                  <v-text-field
	                v-model="userNew.fecha_nac"
	                required
                label="Fecha de Nacimiento"
                prepend-icon="mdi-calendar"
                type="date"
                class="ml-4 mr-4"
                outlined
                dense

	              ></v-text-field>

                  <div class="ml-4 mr-4 mt-4">
                    <div class="firma-label">Firma</div>
	                    <div ref="signatureWrapper" class="signature-wrapper">
	                      <canvas
	                        ref="signatureCanvas"
	                        class="signature-canvas"
	                        @pointerup="actualizarFirmaDesdeCanvas"
	                        @mouseup="actualizarFirmaDesdeCanvas"
	                        @touchend="actualizarFirmaDesdeCanvas"
	                      ></canvas>
	                    </div>
                    <div v-if="firmaError" class="firma-error">
                      {{ firmaError }}
                    </div>
	                  </div>
		                  
		                  <div class="signature-actions ml-4 mr-4">
	                    <div class="signature-actions-top">
                      <v-btn
                        text
                        class="mt-0"
                        @click="limpiarFirma"
                      >
	                        Limpiar firma
	                      </v-btn>
	                    </div>
	                    <v-checkbox
	                      v-model="aceptaCondiciones"
	                      class="legal-checkbox mt-2"
	                      required
	                    >
	                      <template v-slot:label>
	                        <span class="legal-checkbox-text">
	                          Acepto las
	                          <a
	                            :href="enlacesLegalesProveedor.condiciones"
	                            target="_blank"
	                            rel="noopener noreferrer"
	                            @click.stop
	                          >
		                            condiciones y la política de privacidad
	                          </a>
	                          y el
	                          <a
	                            :href="enlacesLegalesProveedor.protocolo"
	                            target="_blank"
	                            rel="noopener noreferrer"
	                            @click.stop
	                          >
	                            protocolo de seguridad
	                          </a>
	                          .
	                        </span>
	                      </template>
	                    </v-checkbox>
	                    <div class="signature-actions-bottom">
		                      <v-btn
		                        class="mt-4 pl-8 pr-8"
	                        :color="colorBoton"
	                        :disabled="!isRegistroCompleto"
	                        @click="_registrar"
	                        v-bind:style="{ color: colorBase }"
	                      >
                        Registrar como acompañante
                      </v-btn>
                    </div>
                  </div>
                </v-form>
                  
                <!--  <registro-form class="mb-6" :userNew="userNew" @login="submit"> </registro-form> -->
              
                 
                </v-card-text>
              </v-card>
          </v-col>
        </v-row>
      </v-container>
   
 </template>

<script>
import base64url from "base64url";
import SignaturePad from "signature_pad";
import logoDefault from "@/assets/icono.png";
import logoCanoaAventura from "@/assets/logo-canoa-aventura.png";
import logoCanoasDelDeva from "@/assets/logo-canoas-del-deva.png";
import RegistroForm from "@/components/Authentication/RegistroForm";
import Modal from "@/components/Modal";
import { mapState, mapActions, mapMutations } from "vuex";
//import * as firebase from "firebase/app";
//import 'firebase/messaging';

export default {
  components: {
    RegistroForm,
    Modal,
  },
  data() {
	    return {
	      reserva: null,
		      dialogRegistrada: false,
		      id: "",
		      signaturePad: null,
		      firmaCompletada: false,
		      aceptaCondiciones: false,
		      firmaError: "",
	      userNew: {
        id: null,
      reserva_id: null,
      cp: null,
      nombre: null,
      foto: null,
      telefono1: null,
      web: null,
      telefono2: null,
      trabajo: null,
      email: null,
      sexo: null,
      localidad: null,
      gustos: null,
      provincia: null,
      autonomia: null,
      instagram: null,
      descripcion: null,
      facebook: null,
      fecha_nac: null,
      comentario_canoe: null,
      res: null,
      dni: null,
      firma_base64: null,
      comentario_cliente: null
      },



      
      userSelec: null,
    };
  },
  computed: {
	    ...mapState("auth", [
	      "user",
	      "date",
      "access_token",
      "error",
	      "errorMessage",
	    ]),
	    ...mapState(["colorBoton", "colorBase"]),
	    proveedorIdReserva() {
	      return Number(this.reserva && this.reserva.proveedor_id);
	    },
	    logoProveedor() {
	      if (this.proveedorIdReserva === 7 || this.proveedorIdReserva === 8) {
	        return logoCanoaAventura;
	      }

	      if (this.proveedorIdReserva === 9 || this.proveedorIdReserva === 10) {
	        return logoCanoasDelDeva;
	      }

	      return logoDefault;
	    },
	    enlacesLegalesProveedor() {
	      if (this.proveedorIdReserva === 7 || this.proveedorIdReserva === 8) {
	        return {
	          condiciones: "https://www.canoaaventura.com/politica-de-privacidad/",
	          protocolo:
	            "https://www.canoaaventura.com/wp-content/uploads/2026/03/protocolo_actuacion_accidentes.pdf",
	        };
	      }

	      if (this.proveedorIdReserva === 9 || this.proveedorIdReserva === 10) {
	        return {
	          condiciones:
	            "https://www.canoasdeldeva.com/terminos-y-condiciones/",
	          protocolo:
	            "https://www.canoasdeldeva.com/wp-content/uploads/2026/03/protocolo_actuacion_accidentes.pdf",
	        };
	      }

	      return {
	        condiciones:
	          "https://www.canoeaventuratrophy.com/condiciones-legales-privacidad/",
	        protocolo:
	          "https://www.canoeaventuratrophy.com/wp-content/uploads/2017/05/protocolo_actuacion_accidentes.pdf",
	      };
	    },
	    camposObligatoriosCompletos() {
	      const campos = [
	        this.userNew.nombre,
	        this.userNew.telefono1,
	        this.userNew.email,
	        this.userNew.dni,
	        this.userNew.fecha_nac,
	      ];

	      return campos.every(
	        (valor) => valor !== null && String(valor).trim() !== ""
	      );
	    },
	    isRegistroCompleto() {
	      return (
	        this.camposObligatoriosCompletos &&
	        !!this.userNew.firma_base64 &&
	        this.aceptaCondiciones
	      );
	    },
	  },

  mounted() {
    this.$nextTick(() => {
      window.requestAnimationFrame(() => {
        this.initializeSignaturePad();
      });
      window.addEventListener("resize", this.resizeSignatureCanvas);
    });

    if (this.$route.params.id) {
      this.id = base64url.decode(this.$route.params.id);
      this._getDatosReserva(this.id);
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeSignatureCanvas);
  },

  updated() {
    if (!this.signaturePad && this.$refs.signatureCanvas) {
      window.requestAnimationFrame(() => {
        this.initializeSignaturePad();
      });
    }
  },

  methods: {
    ...mapActions("auth", ["getDatosReserva", "registrarAcompañante"]),

    initializeSignaturePad() {
      const canvas = this.$refs.signatureCanvas;

      if (!canvas) {
        return;
      }

      if (this.signaturePad) {
        this.signaturePad.off();
      }

	      this.signaturePad = new SignaturePad(canvas, {
	        minWidth: 1,
	        maxWidth: 2.5,
	        penColor: "rgb(33, 150, 243)",
	      });

	      this.signaturePad.onEnd = () => {
	        this.actualizarFirmaDesdeCanvas();
	      };

      this.resizeSignatureCanvas();
    },

    resizeSignatureCanvas() {
      const canvas = this.$refs.signatureCanvas;
      const wrapper = this.$refs.signatureWrapper;

      if (!canvas || !wrapper || !this.signaturePad) {
        return;
      }

      const width = Math.floor(wrapper.clientWidth);
      const height = 220;

      if (!width) {
        return;
      }

      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = width * ratio;
      canvas.height = height * ratio;
	      canvas.style.width = width + "px";
	      canvas.style.height = height + "px";
	      canvas.getContext("2d").scale(ratio, ratio);
	      this.signaturePad.clear();
	      this.firmaCompletada = false;
	      this.userNew.firma_base64 = null;
	    },

	    limpiarFirma() {
	      this.firmaError = "";

      if (!this.signaturePad) {
        return;
      }

	      this.signaturePad.clear();
	      this.firmaCompletada = false;
	      this.userNew.firma_base64 = null;
	    },

	    actualizarFirmaDesdeCanvas() {
	      if (!this.signaturePad || this.signaturePad.isEmpty()) {
	        this.firmaCompletada = false;
	        this.userNew.firma_base64 = null;
	        return;
	      }

	      this.firmaCompletada = true;
	      this.userNew.firma_base64 = this.signaturePad.toDataURL("image/png");
	      this.firmaError = "";
	    },

	    async _registrar() {
	      if (!this.camposObligatoriosCompletos) {
	        return;
	      }
	      if (!this.aceptaCondiciones) {
	        return;
	      }

	      if (!this.signaturePad || this.signaturePad.isEmpty()) {
	        this.firmaError = "La firma es obligatoria.";
	        return;
	      }

      this.firmaError = "";
      this.userNew.reserva_id = this.id;
      this.userNew.firma_base64 = this.signaturePad.toDataURL("image/png");
      let res = await this.registrarAcompañante([this.id, this.userNew]);
      this.dialogRegistrada = true;
    },

    async _getDatosReserva(id) {
      this.reserva = await this.getDatosReserva([id]);
      console.log('reserva', this.reserva);

      /*if (
        this.selectedComercio == null ||
        this.selectedComercio.tipo.nombre !== 'OCIO NOCTURNO'
      ) {
        this._ir('error-no-encontrado');
      }*/
    },
  },
};
</script>

<style scoped>
.firma-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.signature-wrapper {
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 8px;
  overflow: hidden;
}

.signature-canvas {
  display: block;
  width: 100%;
  height: 220px;
  cursor: crosshair;
  pointer-events: auto;
  touch-action: none;
}

.firma-error {
  color: #ffeb3b;
  font-size: 12px;
  margin-top: 8px;
}

.signature-actions-top {
  display: flex;
  justify-content: flex-end;
}

.signature-actions-bottom {
  display: flex;
  justify-content: center;
}

.legal-checkbox-text {
  color: #ffffff;
  font-size: 14px;
  line-height: 1.4;
}

.legal-checkbox-text a {
  color: #ffeb3b;
  font-weight: 600;
  text-decoration: underline;
}
</style>
